// extracted by mini-css-extract-plugin
export default {"svgContainer":"Logo_svgContainer__RXF2F"};